import React from 'react';
import { Plus } from 'lucide-react';

interface FABProps {
  onClick: () => void;
  icon?: React.ReactNode;
}

export const FAB: React.FC<FABProps> = ({ onClick, icon }) => {
  const handleClick = () => {
    try {
      window.Telegram?.WebApp?.HapticFeedback?.impactOccurred('medium');
    } catch {}
    onClick();
  };

  return (
    <button
      className="fixed bottom-20 right-4 w-14 h-14 rounded-full shadow-lg flex items-center justify-center active:opacity-80 transition-opacity"
      style={{ backgroundColor: 'var(--accent)' }}
      onClick={handleClick}
    >
      {icon || <Plus size={28} color="#FFFFFF" strokeWidth={2.5} />}
    </button>
  );
};
